import React, { useEffect, useState } from 'react';
import Loader from '../common/Loader';
import { useDispatch, useSelector } from 'react-redux';
import { clearErrors, getProducts } from '../../redux/actions/productAction';
import { toast } from 'react-hot-toast';
import SectionHeading from '../common/SectionHeading';
import { Col, Container, Row } from 'react-bootstrap';
import Product from './Product';
import { useParams } from 'react-router-dom';
import Slider from '@mui/material/Slider';
import { Checkbox, FormControlLabel, Pagination } from '@mui/material';
import categoryList from '../../constants/category.json';
import MetaData from '../MetaData';

const Products = () => {
    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState(1);
    const [category, setCategory] = useState(null);
    const [range, setRange] = useState([1, 25000]);
    const [ratings, setRatings] = useState(0);
    const { loading, products, error, productsCount, resultPerPage, filteredProductsCount } =
        useSelector((state) => state.products);
    const keyword = useParams().keyword;

    useEffect(() => {
        if (error) {
            toast.error(error);
            dispatch(clearErrors());
        }
        dispatch(getProducts(keyword, currentPage, range, category, ratings));
    }, [dispatch, keyword, currentPage, category, ratings]);

    useEffect(() => {
        setTimeout(() => {
            dispatch(getProducts(keyword, currentPage, range, category, ratings));
        }, 500);
    }, [range]);

    const handlePageChange = (e, value) => {
        setCurrentPage(value);
    };

    const handleRange = (e, newValue) => {
        setRange(newValue);
    };

    const handleRating = (e, newValue) => {
        setRatings(newValue);
    };

    const handleCategorySelection = (val) => {
        if (category === val) {
            setCategory(null);
        } else {
            setCategory(val);
        }
    };

    return loading ? (
        <Loader />
    ) : (
        <>
            <MetaData title={'Products - ShipShop'} />
            <div id='allProducts' className='section-padding-top section-padding-bottom'>
                <Container>
                    <SectionHeading heading={'Products'} />
                    <Row>
                        <Col md={3}>
                            <div className='sideFilters'>
                                <h4 className='common-h4'>Price Range</h4>
                                <div className='px-3'>
                                    <Slider
                                        value={range}
                                        onChange={handleRange}
                                        valueLabelDisplay='auto'
                                        aria-aria-labelledby='range-slider'
                                        min={0}
                                        max={25000}
                                        size='small'
                                    />
                                </div>
                                <label>
                                    {range[0]} - {range[1]}
                                </label>
                                <hr />
                                <h4 className='common-h4'>Categories</h4>
                                <ul className='list-unstyled'>
                                    {categoryList.map((cat, i) => (
                                        <li key={i}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={category === cat}
                                                        color='primary'
                                                        onChange={() =>
                                                            handleCategorySelection(cat)
                                                        }
                                                    />
                                                }
                                                label={cat}
                                            />
                                        </li>
                                    ))}
                                </ul>
                                <hr />
                                <h4 className='common-h4'>Ratings Above</h4>
                                <div className='px-3'>
                                    <Slider
                                        value={ratings}
                                        onChange={handleRating}
                                        valueLabelDisplay='auto'
                                        aria-aria-labelledby='continuous-slider'
                                        min={0}
                                        max={5}
                                        size='small'
                                    />
                                </div>
                            </div>
                        </Col>
                        <Col md={8}>
                            {products && products.length > 0 ? (
                                <>
                                    <div className='productsSection'>
                                        {products.map((product, i) => (
                                            <Product key={i} product={product} />
                                        ))}
                                    </div>
                                    {resultPerPage < filteredProductsCount && (
                                        <Pagination
                                            className='productPagination'
                                            count={Math.ceil(productsCount / resultPerPage)}
                                            onChange={handlePageChange}
                                            page={currentPage}
                                        />
                                    )}
                                </>
                            ) : (
                                <div className='text-center'>No Products Found</div>
                            )}
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
};

export default Products;
